module.exports = __webpack_public_path__ + "static/media/model-x.21ac0164.jpg";